import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface DashboardMetrics {
  sales: {
    pipelineValue: number;
    committedValue: number;
    winRate90d: number;
    winsCount90d: number;
    lossesCount90d: number;
    avgCycleDays: number;
    byStage: Record<string, { count: number; value: number }>;
    atRisk: Array<{
      id: string;
      title: string;
      customerName: string;
      customerId: string | null;
      reason: 'red' | 'amber' | 'green' | 'na';
    }>;
    wonThisMonth: Array<{
      id: string;
      name: string;
      totalCost: number;
      currency: 'GBP' | 'USD' | 'EUR';
      customerName: string;
    }>;
    wonThisMonthValue: number;
  };
  preSales: {
    activeScopings: number;
    pendingReviews: number;
    workshopsScheduled: Array<{
      id: string;
      name: string;
      customerName: string;
      targetDate: string;
    }>;
    myActiveScopings: Array<{
      id: string;
      name: string;
      customerName: string;
      currentScopingStage: string | null;
      totalCost: number;
      currency: 'GBP' | 'USD' | 'EUR';
    }>;
  };
  delivery: {
    activeProjects: number;
    uniqueCustomers: number;
    totalValue: number;
    daysThisMonth: number;
    health: {
      green: number;
      amber: number;
      red: number;
      na: number;
    };
  };
  forYou: {
    reviewsWaiting: number;
    projectsNeedingAttention: Array<{
      id: string;
      name: string;
      customerName: string;
      healthStatus: 'green' | 'amber' | 'red' | 'na';
      currentScopingStage: string | null;
      totalCost: number;
      currency: 'GBP' | 'USD' | 'EUR';
    }>;
    staleOpportunities: Array<{
      id: string;
      title: string;
      customerName: string;
      customerId: string | null;
      daysSinceUpdate: number;
      servicesValue: number;
      currency: 'GBP' | 'USD' | 'EUR';
    }>;
  };
  overview: {
    pipelineCount: number;
    pipelineValue: number;
    committedCount: number;
    committedValue: number;
    inDeliveryCount: number;
    inDeliveryHealth: {
      green: number;
      amber: number;
      red: number;
      na: number;
    };
  };
}

export function useDashboardMetrics() {
  return useQuery({
    queryKey: ['dashboard', 'metrics'],
    queryFn: () => api.get<DashboardMetrics>('/dashboard/metrics'),
    staleTime: 60 * 1000,
  });
}
